export const baseGetLeadAttributeOptions = (fields: string[] = []) => `
  query LeadAttributeOptions($id: Int!, $searchString: String, $includeIds: [ID!]){
    leadAttributeOptions(leadAttributeId: $id, searchString: $searchString, includeIds: $includeIds) {
      value: id
      label: optionName
      ${fields.join('\n')}
    }
  }
`;

export const getLeadAttributeOptions = baseGetLeadAttributeOptions();

export const getLeadAttributeOptionsWithFields = (fields: string[]) => baseGetLeadAttributeOptions(fields);

export const getLeadAttributeOptionsBySchemaName = `
  query LeadAttributeOptions($schemaName: String!){
    leadAttributeOptions(leadAttributeSchemaName: $schemaName) {
      value: id
      label: optionName
    }
  }
`;

export interface GetLeadAttributeOptionsType {
  leadAttributeOptions: {
    value: string;
    label: string;
    isDefault?: boolean;
  }[];
}
